import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

const TypedText = () => {
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        " TURNING CLICKs INTO CLIENTs.",
        // "& INTO CLIENTs.",
        // "& Web Designer.",
        // "& Front End Developer.",
        // "& Back End Developer."
      ],
      typeSpeed: 200,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <span  className="text-5xl font-semibold text-secondary" >
      <span ref={el}></span>
    </span>
  );
};

export default TypedText;
